<template>
  <div class="mask">
    <div class="dialog dialog-top-in" ref="dialog">
      <slot></slot>
      <span class="close" @click="handleClose"></span>
    </div>
  </div>
</template>

<script>
import { addGA } from '@/utils/assist'
import anime from '@/utils/animation'

export default {
  props: {
    dialogType: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClose () {
      const { dialogType } = this
      addGA(`close-${dialogType}-dialog`, 'click')
      this.$bus[`${dialogType}DialogShow`] = false
    }
  },
  watch: {
    '$bus.ruleDialogShow': {
      handler (current) {
        if (current) {
          anime.topIn(this.$refs.dialog)
        }
      }
    },
    '$bus.historyDialogShow': {
      handler (current) {
        if (current) {
          anime.topIn(this.$refs.dialog)
        }
      }
    },
    '$bus.spendDialogShow': {
      handler (current) {
        if (current) {
          anime.topIn(this.$refs.dialog)
        }
      }
    },
    '$bus.discountDialogShow': {
      handler (current) {
        if (current) {
          anime.topIn(this.$refs.dialog)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background-color: $opacity;

  .dialog {
    @include px2res(width, 864);
    @include px2res(height, 480);
    @include px2res(padding, 30, 100, 20, 53);

    &.dialog-top-in {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .close {
      position: absolute;
      @include px2res(top, 8);
      @include px2res(left, -65);
      @include px2res(width, 48);
      @include px2res(height, 48);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/mask/index.vue